import {
  initSetup,
  createPreviewComponents,
  prefetchCustomCSM,
  createPreview,
  unstable_createPageSSRComponents,
} from './previewerApi';
import type {
  CreatePageSSRComponentsParams,
  CreatePreviewComponentsParams,
  CreatePreviewParams,
} from './types';
import type { MiniSiteManager } from '@wix/document-services-types';

export interface StandalonePreviewerApi {
  createPreviewComponents: (
    params: CreatePreviewComponentsParams,
  ) => Promise<React.ReactElement>;
  createPreview: (params: CreatePreviewParams) => Promise<React.ReactElement>;
  unstable_createPageSSRComponents: (
    params: CreatePageSSRComponentsParams,
  ) => Promise<React.ReactElement>;
  prefetchCustomCSM: (publishedTemplateMetasiteId: string) => Promise<void>;
}

export const createStandalonePreviewerApi = async (
  miniSiteManager: MiniSiteManager,
) => {
  initSetup(miniSiteManager);

  const { ds, createPreviewElements } = miniSiteManager;

  const standalonePreviewerApi = {
    createPreviewComponents: async (params: CreatePreviewComponentsParams) => {
      return createPreviewComponents(ds, createPreviewElements, params);
    },
    createPreview: async (params: CreatePreviewParams) => {
      return createPreview(ds, createPreviewElements, params);
    },
    prefetchCustomCSM: async (publishedTemplateMetasiteId: string) => {
      return prefetchCustomCSM(ds, publishedTemplateMetasiteId);
    },
    unstable_createPageSSRComponents: async (
      params: CreatePageSSRComponentsParams,
    ) => {
      return unstable_createPageSSRComponents(ds, params);
    },
  };

  return standalonePreviewerApi;
};
